module.exports = __webpack_public_path__ + "img/monk.82236a3a.jpg";